import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_bf_sellable_bags",
  stages: {
    affected_users: 1, // All users on SR who hovered on the BF card and users on BF page
    main: 2, // User sees sellable baggage
    ddot: 3,
    mdot: 4,
    bf_page: 5,
    sellable_bag_on_upsell: 6,
    multi_travellers: 7,
    solo_travellers: 8,
    af_or_klm: 9
  },
  goals: {
    bag_footer_visible: 1
  },
  defaultStage: 1
});

const trackStages = (isMobile: boolean, travellers?: number, sellableFeaturesRequiredByAirline?: boolean) => {
  utils.stages.main();
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
  if (travellers === 1) utils.stages.solo_travellers();
  if (travellers && travellers > 1) utils.stages.multi_travellers();
  if (sellableFeaturesRequiredByAirline) utils.stages.af_or_klm();
};

export default { trackStages, ...utils };
